export function getDate(time) {
    if (time === undefined || time == null) {
        return
    }
    let today = new Date();
    let date = formatDate(time);
    if (today.getFullYear() === date.getFullYear()) {
        if (today.getMonth() === date.getMonth()) {
            if (today.getDate() === date.getDate()) {
                return '今天'
            } else if (today.getDate() === date.getDate() + 1) {
                return '昨天'
            }
        }
        return datePlusZero(date.getMonth() + 1) + '-' + datePlusZero(date.getDate());
    }
    return date.getFullYear() + '-' + datePlusZero(date.getMonth() + 1) + '-' + datePlusZero(date.getDate());
}

export function getTimeOfDay(time) {
    if (time === undefined || time == null) {
        return
    }
    let date = formatDate(time);
    return date.getHours() + ':' + datePlusZero(date.getMinutes());
}

export function datePlusZero(number) {
    return number >= 10 ? number : '0' + number;
}

export function formatDate(date) {
    return new Date(Date.parse(date.replace(/-/g, "/")));
}

export function getNamedDate(time) {
    return getDate(time) + ' ' + getTimeOfDay(time);
}
